import { rs } from "./rs";
import { en } from "./en";
import { LocaleStrings } from "../LocaleStrings";

const langs = {rs, en} as Record<string, LocaleStrings>;

export default langs;
